import { render, staticRenderFns } from "./AddEditTestResult.vue?vue&type=template&id=0d9c0a9c"
import script from "./AddEditTestResult.vue?vue&type=script&lang=js"
export * from "./AddEditTestResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports